var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 4.2v11.576l3.987-3.99.213-.214.214.214 3.386 3.39 5.787-5.79.213-.214.214.214L21 13.376V4.2zm0 12.423V19.8h3.177l4.2-4.2L7.2 12.423zm13.8-6.6L7.024 19.8H21v-5.577zM2.4 3.6h19.2v16.8H2.4V3.6m6.3 4.8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-3.6 0a2.1 2.1 0 1 1 4.2 0 2.1 2.1 0 0 1-4.2 0"
  })));
};
export default SvgImage;